import * as React from 'react';
import './not-found.scss';

export const NotFound = (): JSX.Element => <div>404</div>;
